import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
     
    {
      path: "/",
      redirect: "/dashboard",
      meta: { main_page: true },
      component: () => import("./core/plugins/TitleRibbon/index"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { main_page: true },
          component: () => import("./core/plugins/TitleRibbon/Dashboard"),
        },
        {
          path: "/admin/products/:productsku/:productId/varients",
          name: "ProductSkusManager",
          component: () => import("@/view/pages/admin/palcemarketing/ProductSkusManager.vue"),
          meta: { title: "مدیریت تنوع‌های محصول", has_ribbon: true },
          props: true 
        },

         {
          path: "/admin/products",
          name: "admin.products",
          component: () => import("@/view/pages/admin/palcemarketing/ProductsList.vue"),
        meta: { title: "مانیتورینگ محصولات", has_ribbon: true },

        }, {
          path: "/admin/placemarketing",
          name: "admin.placemarketing",
          component: () => import("@/view/pages/admin/product/MarketplaceListings.vue"),
        meta: { title: "مانیتورینگ مارکت پلیس", has_ribbon: true },

        },    
        {
          path: "/admin/smartpricing",
          name: "admin.smartpricing",
          component: () => import("@/view/pages/admin/SmartPricing/SmartPricingStrategies.vue"),
        meta: { title: "استراتژی‌های قیمت‌گذاری هوشمند", has_ribbon: true },

        }, 
          {
          path: "/admin/buyers",
          name: "admin.buyers",
          component: () => import("@/view/pages/digi/PurchasesTab.vue"),
           meta: { title: "لیست خریداران", has_ribbon: true },

        },
       
         {
          path: "/admin/digisetting",
          name: "admin.digisetting",
          component: () => import("@/view/pages/digi/DigikalaSettings.vue"),
           meta: { title: "تنظیمات محموله", has_ribbon: true },

        }, 
         {
          path: "/admin/reportjob",
          name: "admin.reportjob",
          component: () => import("@/view/pages/digi/RepricerReportTab.vue"),
           meta: { title: "گزارش جاب", has_ribbon: true },

        }, 
          {
          path: "/admin/pricingManagment",
          name: "admin.pricingManagment",
          component: () => import("@/view/pages/digi/PricingManagement.vue"),
           meta: { title: "مدیریت قیمت گذاری", has_ribbon: true },

        },
        {
          path: "/admin/deactive",
          name: "admin.Price_deactive",
          component: () => import("@/view/pages/digi/productVarinetAll.vue"),
           meta: { title: "تنوع محصول", has_ribbon: true },

        },
        {
          path: "/admin/createTextBatch",
          name: "admin.createTextbatch",
          component: () => import("@/view/pages/generate_QrText/IndexBatchQr.vue"),
           meta: { title: "ساخت متن دسته ای", has_ribbon: true },

        },
        
        {
          path: "/admin/sellsettings",
          name: "admin.sellsettings",
          component: () => import("@/view/pages/admin/SettingsPage/SettingsPageAll.vue"),
           meta: { title: "تنظیمات فروش و رقابت", has_ribbon: true },

        },
        {
          path: "/admin/onlinestore",
          name: "admin.onlineStore",
          component: () => import("@/view/pages/admin/SettingsPage/OnlineStores.vue"),
           meta: { title: "فروشگاه آنلاین", has_ribbon: true },
        },
         {
          path: "/test/devicetester",
          name: "test.devicetester",
          component: () => import("@/view/pages/test/DeviceTester.vue"),
           meta: { title: "تست گوشی کاربر", has_ribbon: true },
        },
        
         {
          path: "/admin/store",
          name: "admin.Store",
          component: () => import("@/view/pages/phycialStore/PhysicalProductList.vue"),
           meta: { title: "مدیریت محصولات فیزیکی", has_ribbon: true },
        },
        //  {
        //   path: "/admin/reportjob",
        //   name: "admin.buyer",
        //   component: () => import("@/view/pages/digi/"),
        //    meta: { title: "تنوع های ناقص", has_ribbon: true },

        // },
        // {
        //   path: "/admin/reportjob",
        //   name: "admin.buyer",
        //   component: () => import("/"),
        //    meta: { title: "تنوع ", has_ribbon: true },

        // },
         {
          path: "/divar",
          name: "Numbers",
          component: () =>
              import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "addNewNumber/add",
              name: "addNewNumber",
              meta: {has_ribbon: true, title: 'افزودن شماره خود', permission: 'divar_phone'},
              component: () => import("@/view/pages/numbers/addNewNumbers")
            },
            {
              path: "numberList",
              name: "numberList",
              meta: {has_ribbon: true, title: 'لیست شماره های من', permission: 'number_list'},
              component: () => import("@/view/pages/numbers/numbersList")
            },]
          }


             ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      Vue.nextTick().then(() => {
        if (savedPosition) {
          resolve({ ...savedPosition, behavior: "smooth" });
        } else if (to.name === "qr.list") {
          resolve(false);
        } else {
          resolve({ x: 0, y: 0, behavior: "smooth" });
        }
      });
    });
  },
});
